import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { connect } from 'react-redux'
import ComposeExtraButton from './compose_extra_button'
import { accept_content_types, loggedOut } from '../../../initial_state' // isVPDI
import { openModal } from '../../../actions/modal'
import { MODAL_UNAUTHORIZED, MODAL_PRO_UPGRADE } from '../../../constants'
import { v4 as uuidv4 } from 'uuid';

class UploadButton extends ImmutablePureComponent {
  setFileInputRef = ref => (this.fileInputRef = ref)
  handleClick = () => {
    if (loggedOut) {
      return this.props.loginSignupPrompt()
    }
    //if (!isVPDI) {
    //  return this.props.openProModal('media-upload')
    //}
    this.fileInputRef.click()
  }
  handleChange = e => {
    const files = e.target.files;
    if (files.length > 0) {
      const renamedFiles = Array.from(files).map(file => {
        const fileExtension = file.name.split('.').pop();
        const newFileName = `${uuidv4()}.${fileExtension}`;
        let description = '';
        console.log(file.name);
        if (file.name.includes('.mp3' ) || file.name.includes('.ogg' ) || file.name.includes('.flac') || file.name.includes('.wav') || file.name.includes('.m4a')) { 
          console.log('setting description');
          description = file.name;
        }
        let x = new File([file], newFileName, { type: file.type });
        x.description = description;
        console.log('x', x);
        return x;
      });
      this.props.onUpload(renamedFiles);
    }
  }
  render() {
    const { resetFileKey, disabled, small = true } = this.props
    return (
      <ComposeExtraButton
        title='Photo/Video'
        disabled={disabled}
        onClick={this.handleClick}
        small={small}
        icon="media"
        iconClassName={_s.cIconComposeMedia}
      >
        <label>
          <span className={_s.displayNone}>
            Add media (JPEG, PNG, GIF, WebM, MP4, MOV)
          </span>
          <input
            key={resetFileKey}
            ref={this.setFileInputRef}
            type="file"
            accept={accept_content_types.join(',')}
            onChange={this.handleChange}
            disabled={disabled}
            className={_s.displayNone}
            multiple
          />
        </label>
      </ComposeExtraButton>
    )
  }
}

UploadButton.propTypes = {
  disabled: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
  resetFileKey: PropTypes.string,
  small: PropTypes.bool
}

const mapDispatchToProps = dispatch => ({
  loginSignupPrompt: () => dispatch(openModal(MODAL_UNAUTHORIZED)),
  openProModal: () => dispatch(openModal(MODAL_PRO_UPGRADE))
})

export default connect(null, mapDispatchToProps)(UploadButton)
